// @react
import React, { ReactElement } from 'react'
// @components
import DocumentTitle from 'react-document-title'
import PageTitle from '@bit/atd.web.page-title'
// @module Components
import TopicsList from 'modules/common/components/TopicsList'
import PageWrapper from 'modules/profile/components/PageWrapper'
import Grid from '@bit/atd.web.grid'
import Typography from '@material-ui/core/Typography'

/**
 * 5.0.2 Profile - Password & Security
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

const Topics = (): ReactElement => {
  return (
    <PageWrapper>
      <DocumentTitle title="Profile - Topics | ATD">
        <>
          <PageTitle subtitle="The topics you follow will help us serve you content relevant to your interests.">
            My Topics
          </PageTitle>
          <Grid container>
            <Grid xs={12} item>
              <Typography variant="body1" component={'p'}>
                Your website experience will be customized based on the topics
                you select. Some topics have been added automatically based on
                your information, but you can edit your topics at any time.
              </Typography>
            </Grid>
          </Grid>
          <TopicsList />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Topics
